import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface TagProps {
  tag: string;
  onRemove?: (() => void) | null;
  disabled?: boolean;
  className?: string;
  size?: "sm" | "md";
}

export const systemTags = [
  "mismatch",
  "multiple",
  "documentai",
  "ocr",
  "empty-form",
  "unreadable",
];

export default function Tag({
  tag,
  onRemove,
  disabled = false,
  className,
  size = "md",
}: TagProps) {
  const baseStyles = "inline-flex items-center rounded-full font-medium whitespace-nowrap";
  const sizeStyles = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-0.5 text-sm",
  };
  // const colorStyles = onRemove
  //   ? "bg-blue-100 text-blue-800 hover:bg-blue-200"
  //   : "bg-gray-100 text-gray-800";

  const isSystemTag = systemTags.includes(tag);

  return (
    <span
      className={twMerge(
        clsx(
          baseStyles,
          sizeStyles[size],
          "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100",
          className,
          isSystemTag
            ? "bg-gray-100 text-gray-800 dark:bg-zinc-700 dark:text-zinc-100"
            : "",
          ["exclude-from-training"].includes(tag)
            ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100"
            : "",
          disabled && "opacity-50 cursor-not-allowed"
        )
      )}
    >
      {tag}
      {onRemove && !isSystemTag && (
        <button
          onClick={onRemove}
          disabled={disabled}
          className={clsx(
            "ml-1.5 inline-flex items-center justify-center rounded-full hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed",
            size === "sm" ? "w-3 h-3" : "w-4 h-4"
          )}
        >
          <XMarkIcon className={size === "sm" ? "h-2 w-2" : "h-3 w-3"} />
        </button>
      )}
    </span>
  );
}
